import { render, staticRenderFns } from "./StudyFileUploader.vue?vue&type=template&id=ac63c30a&scoped=true&"
import script from "./StudyFileUploader.vue?vue&type=script&lang=ts&"
export * from "./StudyFileUploader.vue?vue&type=script&lang=ts&"
import style0 from "./StudyFileUploader.vue?vue&type=style&index=0&id=ac63c30a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac63c30a",
  null
  
)

export default component.exports